const sidebarHandler = () => {
  const sidebar = document.querySelector(".post__sidebar-wrapper");
  const sidebarMenuWrapper = document.querySelector(
    ".post__sidebar-menu-clickable"
  );
  const sidebarButton = document.querySelector(".toggle-side-menu-button");

  if (sidebar && sidebarButton) {
    sidebarMenuWrapper.addEventListener("click", (e) => {
      if (!sidebar.classList.contains("sidebarOpen")) {
        sidebar.classList.add("sidebarOpen");
        e.stopPropagation();
      }
    });

    sidebarButton.addEventListener("click", (e) => {
      sidebar.classList.toggle("sidebarOpen");
      e.stopPropagation();
    });

    // Close the sidebar if clicked outside
    document.addEventListener("click", (e) => {
      if (sidebar.classList.contains("sidebarOpen") && !sidebar.contains(e.target) && !sidebarButton.contains(e.target)) {
        sidebar.classList.remove("sidebarOpen");
      }
    });
  }
};

if (document.readyState !== "loading") {
  sidebarHandler();
} else {
  document.addEventListener("DOMContentLoaded", sidebarHandler);
}